module.exports = __webpack_public_path__ + "media/images/android-chrome-144x144-be17ff115b3bf2a672b0e2968af1fec1.png";